const StockAvailabilityStatusMap = {
  AVAILABLE_TO_ORDER: {cssClass: "available_to_order", iconClass: "zmdi zmdi-alert-circle", text: "Available to order", eventText: "Available to Order In"},
  IN_STOCK: {cssClass: "in_stock", iconClass: "zmdi zmdi-check-circle", text: "In stock", eventText: "In Stock"},
  LOW_STOCK: {cssClass: "low_stock", iconClass: "zmdi zmdi-alert-circle", text: "Low stock", eventText: "Low Stock"},
  NO_LONGER_AVAILABLE: {cssClass: "no_longer_available", iconClass: "zmdi zmdi-alert-circle", text: "No longer available", eventText: "Not Available"}
};

export default StockAvailabilityStatusMap;